<template>
    <div class="row flex draggable">
        <draggable v-for="area in areas" :key="area.name" v-model="area.components"
                   class="flex__item flex--column draggable__item"
                   :class="area.class" :options="dragOptions" @change="onWidgetMove">
            <component v-for="(component, index) in area.components" :key="index" :query="query"
                       v-model="component.model" :is="component.class"/>
        </draggable>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import draggable from 'vuedraggable';
    import QuickInsightsWidget from '../widgets/quick-insights/QuickInsightsWidget';
    import SellersWidget from '../widgets/sellers/SellersWidget';
    import GeoTableWidget from '../widgets/geotable/GeoTableWidget';
    import TrackerGraphWidget from '../widgets/tracker-graph/TrackerGraphWidget';

    @Component({
        components: {
            draggable
        }
    })
    export default class WidgetDragArea extends Vue {
        @Prop()
        query;
        areas = [
            {
                name: 'top',
                class: 'col-xl-12',
                components: [
                    {class: TrackerGraphWidget, model: {}},
                ],
            },
            {
                name: 'left',
                class: 'col-xl-7 col-md-12',
                components: [
                    {class: SellersWidget, model: {}},
                ],
            },
            {
                name: 'right',
                class: 'col-xl-5 col-md-12',
                components: [
                    {class: QuickInsightsWidget, model: {}},
                ],
            },
            {
                name: 'bottom',
                class: 'col-xl-12',
                components: [
                    {class: GeoTableWidget, model: {}},
                ],
            },
        ];
        dragOptions = {
            group: 'widgets',
            handle: '.widget__handle',
            ghostClass: 'widget__ghost',
            dragClass: 'widget__drag',
        };

        onWidgetMove(event) {
            // The event is triggered twice, once for removing the widget from the old container and once for adding it to a different one.
            // To handle this we perform the logic on the next tick and ignore all further updates until the next tick has arrived.
            if (!this.changeTriggered) {
                this.changeTriggered = true;
                Vue.nextTick().then(() => {
                    this.changeTriggered = false;
                    this.onWidgetLayoutChanged();
                });
            }
        }

        onWidgetLayoutChanged() {
            // TODO: Opportunity to implement widget layout saving
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/WidgetDragArea.vue